<app-enfaf-modal
  svgIcon="modal-calendar"
  [title]="'Configurar fechas del diploma'"
  [buttonCancelText]="'Cancelar'"
  [buttonConfirmText]="'Guardar'"
  [disableConfirmButton]="!canSave || isSaving"
  [isLoading]="isSaving"
  (onConfirm)="onConfirm()"
  (onClose)="onClose()"
>
  <p class="modal-diploma-dates__description">
    Configura el período formativo para el diploma de <strong>{{ data.courseName }}</strong
    >.
  </p>

  <div class="modal-diploma-dates__fields">
    <div class="modal-diploma-dates__field">
      <enfaf-datetime-picker-dark
        [control]="startDateControl"
        label="Fecha de inicio"
        placeholder="Selecciona fecha de inicio"
        [hideTime]="true"
        [showSpinners]="false"
      />
    </div>

    <div class="modal-diploma-dates__field">
      <enfaf-datetime-picker-dark
        [control]="endDateControl"
        label="Fecha de fin"
        placeholder="Selecciona fecha de fin"
        [hideTime]="true"
        [showSpinners]="false"
        [minDate]="endDateMinDate"
      />
    </div>
  </div>
</app-enfaf-modal>
